import { IAuthorityModification } from './authority-modification.interface';
import { DataShareService } from '../services/data-share.service';
import { AppConstant } from '../common/app.constant';

export class AuthorityModificationModal {
  changeText: string;
  changeTimeStamp: Date;
  requestedBy: string;
  changeType: string;
  dispatcher: String;
  operateOn: String;
  rejectedBy: string;
  rejectionReason: string;
  multipleModifications: string[] = [];

  constructor(private authorityModification: IAuthorityModification, private dataShareService: DataShareService) {
    this.changeText = this.authorityModification.changeText ? this.authorityModification.changeText : null;
    this.changeTimeStamp = this.authorityModification.changeTimeStamp
      ? new Date(authorityModification.changeTimeStamp.toString().slice(0, -5))
      : null;
    this.requestedBy =
      this.authorityModification.requestedById + this.authorityModification.requestedByName
        ? this.authorityModification.requestedById +
          ' - ' +
          this.dataShareService.getNameByFirstAndLastName(this.authorityModification.requestedByName)
        : '';
    this.changeText = this.authorityModification.changeText ? this.authorityModification.changeText : null;
    this.dispatcher = this.authorityModification.dispatcher ? this.authorityModification.dispatcher : null;
    this.multipleModifications = this.authorityModification.multipleModifications;
    if (this.authorityModification.rejectedById) {
      if (this.authorityModification.rejectedById === AppConstant.DISPATCHER_TEXT) {
        this.rejectedBy = this.authorityModification.rejectedById;
      } else {
        this.rejectedBy =
          this.authorityModification.rejectedById +
          ' - ' +
          this.dataShareService.getNameByFirstAndLastName(this.authorityModification.rejectedByName);
      }
    } else {
      this.rejectedBy = null;
    }
    this.rejectionReason = this.authorityModification.rejectionReason || null;
  }
}
